import { MODELS } from '@/plugins/models';
import Tournament from '../tournament/index';

const getGroup = async (activeNomination, groupId, event) => {
  const groups = activeNomination?.groups || [];
  const activeGroup = groups.find(({ id }) => id === groupId) || groups.at(0);
  if (!activeGroup) {
    const { item } = await MODELS.group.objects.create({ data: {
      event_id: event.id,
      name: DEFAULT_NAME_GROUP,
    } });
    await MODELS.group.objects.nominationAttach({
      args: [activeNomination.id],
      data: { groups: [item.id] },
    });
    return item;
  }
  return activeGroup;
};
const getTour = async (nomination, group, tournaments, event) => {
  const tour = tournaments.find(({ event_group_id }) => event_group_id === group.id);
  if (!tour) {
    const { item } = await MODELS.tournament.objects.create({ data: {
      event_id: event.id,
      event_group_id: group.id,
      nomination_id: nomination.id,
      name: `${Tournament.constants.DEFAULT_NAMES.tournament} - ${nomination.name}`,
    } });
    return item;
  }
  return tour;
};
const getTourStage = async (tournament) => {
  const [stage] = tournament?.stages || [];
  if (!stage) {
    const { item } = await MODELS.tournament.stages.create({ data: {
      tournament_id: tournament.id,
      name: `${Tournament.constants.DEFAULT_NAMES.stage} - ${tournament.name}`,
    } });
    return item;
  }
  return stage;
};
const getTourStageGroup = async (stage) => {
  const [group] = stage?.groups || [];
  if (!group) {
    const { item } = await MODELS.tournament.groups.create({ data: {
      tournament_stage_id: stage.id,
      name: `${Tournament.constants.DEFAULT_NAMES.group} - ${stage.name}`,
    } });
    return item;
  }
  return group;
};

const createPathForTourGroup = async ({ event, nominationId, groupId, tournaments }) => {
  const { nominations } = event;
  const activeNomination = nominations.find(({ id }) => id === nominationId) || nominations.at(0);
  const activeGroup = await getGroup(activeNomination, groupId, event);
  const activeTour = await getTour(activeNomination, activeGroup, tournaments, event);
  const activeTourStage = await getTourStage(activeTour);
  const activeTourStageGroup = await getTourStageGroup(activeTourStage);
  return activeTourStageGroup;
};

export default {
  createPathForTourGroup,
};
